import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

@Component({
  selector: 'pulse-footer',
  imports: [],
  templateUrl: './pulse-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseFooterComponent {
  copyrightYear = signal(new Date().getFullYear());
}
